import _ from 'lodash';
//import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import PlcChangeContainer from '../../containers/accounting/PlcChanges';

import { getSharedStyles } from '../../themes';
import EnhancedTable from '../../components/table/EnhancedTable';
import { Button, Typography } from '@material-ui/core';
import AddPlcDialog from '../../components/AddPlcDialog';
//import Button from '@material-ui/core/Button';
const styles = (theme) => ({
	...getSharedStyles(theme),
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	docContainer: {
		position: 'absolute',
	},
	addInputButton: {
		borderRadius: '100px',
		marginBottom: 10,
	},
});

const plcChangeColumns = [
	{
		sortId: 'plcChangeId',
		displayId: 'plcChangeId',
		labels: ['Change ID'],
	},

	{
		sortId: 'newValue',
		displayId: 'newValue',
		label: 'New Value',
	},
	{
		sortId: 'previousValue',
		displayId: 'previousValue',
		label: 'Previous Value',
	},

	{
		sortId: 'createdByDisplay',
		displayId: 'createdByDisplay',
		labels: ['Created By'],
	},

	{
		sortId: 'message',
		displayId: 'message',
		labels: ['Note'],
	},

	{
		sortId: 'startDate',
		displayId: 'dateCreatedFormatted',
		label: 'Date Created',
	},
];

class PlcChanges extends Component {
	constructor(props) {
		super(props);
		this.state = {
			order: 'desc',
			orderBy: 'dateCreated',
			isAddDialogOpen: false,
		};
	}

	componentDidMount() {
		const { plcChangeSearch } = this.props;
		plcChangeSearch();
	}

	componentDidUpdate(prevProps) {
		const { plcChanges } = this.props;
		if (prevProps.plcChanges !== plcChanges) {
			this.formatPlcChanges();
		}
	}

	formatPlcChanges = () => {
		const { plcChanges, userMap } = this.props;
		const formattedPlcChanges = [];
		plcChanges.forEach((plcChange) => {
			const {
				plcChangeId,
				//	newValue,
				//	previousValue,
				//message,
				createdByUserId,
				dateCreated,
			} = plcChange;
			const createdByUser = userMap[createdByUserId] || { firstName: 'Missing' };

			plcChange.key = plcChangeId;
			plcChange.createdByDisplay = createdByUser.firstName;
			plcChange.dateCreatedFormatted = moment(dateCreated).format('M/D h:mm a');
			formattedPlcChanges.push(plcChange);
		});
		this.setState({ formattedPlcChanges });
	};

	handleCloseAddDialog = () => {
		this.setState({ isAddDialogOpen: false });
	};

	render() {
		const { classes, authUser, canRwPlc } = this.props;

		if (!canRwPlc) {
			return <div>You have invalid permissions to view this page.</div>;
		}

		const canMakeUpdates = _.get(authUser, ['permissions', 'canMakeUpdates']);
		const { formattedPlcChanges, order, orderBy } = this.state;

		if (!formattedPlcChanges) {
			return <div>Loading the PLC changes...</div>;
		}

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={8}>
							<Typography variant="h5" align="left" gutterBottom className={classes.title}>
								<span>PLC Change History</span>
							</Typography>
						</Grid>

						<Grid item xs={4} style={{ textAlign: 'right' }}>
							<Button
								onClick={() => {
									this.setState({ isAddDialogOpen: true });
								}}
								variant="contained"
								color="primary"
								className={classes.addInputButton}
								disabled={!canMakeUpdates}
								style={{ marginTop: 0 }}
							>
								Update Current PLC
							</Button>
						</Grid>
					</Grid>

					<Paper className={classes.paper}>
						<EnhancedTable
							columns={plcChangeColumns}
							rows={formattedPlcChanges}
							defaultOrder={order}
							defaultOrderBy={orderBy}
						/>
					</Paper>
				</Grid>

				<AddPlcDialog
					onClose={this.handleCloseAddDialog}
					plcChangeAdd={this.props.plcChangeAdd}
					open={this.state.isAddDialogOpen}
					showErrors={this.props.showErrors}
				/>
			</Grid>
		);
	}
}

PlcChanges.propTypes = {
	canRwPlc: PropTypes.bool.isRequired,
	classes: PropTypes.object.isRequired,
	plcChangeSearch: PropTypes.func.isRequired,
	plcChangeAdd: PropTypes.func.isRequired,
	plcChanges: PropTypes.array,
	showErrors: PropTypes.func.isRequired,
	userMap: PropTypes.object,
	history: PropTypes.object,
	theme: PropTypes.object.isRequired,
	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles, { withTheme: true }), PlcChangeContainer])(PlcChanges);
